export type TCarouselItemProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

function CarouselItem({ children, ...props }) {
    return <div {...props}>{children}</div>;
}

export default CarouselItem;
